export const formatNumber = (number, direction) => {

  if (direction) {
    if (!number) return null;

    const cleanedString = number
      .toString()
      .replace(/\s/g, '')     // szóközök törlése
      .replace(',', '.');     // vessző → pont

    return parseFloat(cleanedString);
  }

  return Number(number).toLocaleString('hu-HU');
};